// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-C":"Other_outdoor-recreation-C__moMM6"};